import { Outlet } from "react-router";

import { Box } from "@mui/system";

import notAuthenticatedOnly from "./Base/NotAuthenticatedOnly/NotAuthenticatedOnly";

const UserLayout = () => {
  return (
    <Box
      sx={{
        backgroundImage: "url('/static/images/auth-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Outlet />
    </Box>
  );
};

export default notAuthenticatedOnly(UserLayout);
